export default __webpack_public_path__ + "5bfea27adfeb0ccf668790fa3b8abf1d.png";